import types from "./action-types";

const initialState = {
  // just for use case when one profile chart is on screen for refresh action
  profileId: 0,
};

export default (state = initialState, action) => {
  let newState = state;

  switch (action.type) {
    case types.DATA_LOADED:
      const { id, profileId, nominalProfileId, dataSets } = action.data;
      newState = {
        ...state,
        profileId: profileId,
        nominalProfileId: nominalProfileId,
      };
      newState[id] = {
        loading: false,
        data: dataSets,
      };
      break;
  }

  return newState;
};



// WEBPACK FOOTER //
// ./App/components/modules/profile/reducer.js